import get from 'lodash/get';

const Cart = require('./Cart');

let cart;

const defaultOptions = {
  flowApiBaseURI: 'https://api.flow.io',
};

export function init(options) {
  cart = new Cart(options);
  return cart;
}

/**
 * @param {ShopifySession} [session] Option Shopify Session
 */
export function getCart(session) {
  const cartOptions = session ? {
    ...defaultOptions,
    flowCartId: get(session, 'attributes.cart_id'),
  } : defaultOptions;

  if (!cart) {
    cart = new Cart(cartOptions);
  }

  return cart;
}



// WEBPACK FOOTER //
// ./static/js/v0/cart_unified/cart-unified.js